// extracted by mini-css-extract-plugin
module.exports = {"cardContainer":"card-module--cardContainer--313DW","image":"card-module--image--hMgwV","overlay":"card-module--overlay--3YWgr","text":"card-module--text--2GPHF"};